$(document).ready(function () {
  /**
   * Initializes infinite scrolling for a slider.
   * @param {jQuery} $slider - The slider element.
   * @param {number} speed - Scrolling speed in pixels per frame.
   */
  function initializeSlider($slider, speed) {
    const $slides = $slider.children(".slide");

    // Duplicate slides for seamless looping
    const totalSlides = $slides.length;
    $slider.append($slides.clone());

    // Calculate total width (including duplicated slides)
    const totalWidth = $slides.length * $slides.outerWidth(true) * 2;
    $slider.css("width", totalWidth);
    let currentX = 0; // Current translation value
    function scroll() {
      currentX -= speed;
      if (Math.abs(currentX) >= totalWidth / 2) {
        currentX = 0; // Reset translation
      }
      setTimeout(function () {
        $slider.css("transform", `translateX(${currentX}px)`);
        requestAnimationFrame(scroll);
      }, 40);
    }
    setTimeout(() => requestAnimationFrame(scroll), 1000);
  }

  // Find and initialize all sliders
  $(".slider").each(function () {
    const $slider = $(this);
    const speed = 1; // Default speed: 1px/frame
    initializeSlider($slider, speed);
  });
});
